var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoardMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25875_8808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9748 29.4095C26.881 29.4095 31.669 24.648 31.669 18.7743C31.669 12.9007 26.881 8.13916 20.9748 8.13916C15.0686 8.13916 10.2805 12.9007 10.2805 18.7743C10.2805 24.648 15.0686 29.4095 20.9748 29.4095Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8766 42.5456C38.4212 39.8904 35.3782 37.7363 33.0149 36.2943C29.4709 34.2853 25.2888 33.1909 20.9749 33.1909C15.1911 33.1909 9.64431 35.158 5.55458 38.6594C3.14056 40.7262 1.35093 43.2276 0.289672 45.9488C-0.92444 49.0619 1.86402 51.8615 5.19062 51.8615H36.7592C37.044 51.8615 37.3248 51.841 37.5996 51.8016H45.1511C45.2054 48.4391 43.4261 45.3026 40.8766 42.5456Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1104 32.1559C46.8841 32.1559 50.754 28.286 50.754 23.5123C50.754 18.7386 46.8841 14.8687 42.1104 14.8687C37.3367 14.8687 33.4668 18.7386 33.4668 23.5123C33.4668 28.286 37.3367 32.1559 42.1104 32.1559Z",
    fill: "#4FB5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0812 35.7708C37.854 35.3171 39.706 35.0818 41.5832 35.0818C46.6379 35.0818 51.5286 36.7897 55.171 39.892C56.9055 41.3694 58.4227 42.8823 59.4551 45.0313C59.9203 45.9999 60.1203 47.0101 59.9244 47.9978C59.726 48.998 59.1605 49.7791 58.4552 50.3428C57.117 51.4123 55.1736 51.8017 53.3736 51.8017H47.0579C47.1155 47.6065 44.8766 43.8889 42.1517 40.9423C40.2657 38.9029 38.0813 37.1558 36.0812 35.7708Z",
    fill: "#4FB5F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25875_8808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardMembers);
export default __webpack_public_path__ + "static/media/boardMembers.f1aa75847e0115bb1c9428bef108213e.svg";
export { ForwardRef as ReactComponent };